"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Util_1 = require("../../Services/Util");
var Echo = /** @class */ (function (_super) {
    __extends(Echo, _super);
    function Echo(props) {
        var _this = _super.call(this, props) || this;
        _this.makeCall = function () {
            var _a, _b;
            var echo = (_a = _this.inputRef.current) === null || _a === void 0 ? void 0 : _a.value;
            Util_1.getJson("/Echo?message=" + echo, undefined, (_b = _this.checkBoxRef.current) === null || _b === void 0 ? void 0 : _b.checked).then(function (response) {
                var _a;
                (_a = _this.outputRef.current) === null || _a === void 0 ? void 0 : _a.setAttribute("value", JSON.parse(response));
            }).catch(function (reason) {
                console.error("Echo catch: " + reason);
            });
        };
        _this.inputRef = React.createRef();
        _this.outputRef = React.createRef();
        _this.checkBoxRef = React.createRef();
        return _this;
    }
    Echo.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("input", { type: "text", ref: this.inputRef }),
            React.createElement("button", { onClick: this.makeCall }, " ->"),
            React.createElement("input", { type: "text", ref: this.outputRef }),
            React.createElement("br", null),
            "Enable Auth ",
            React.createElement("input", { type: "checkbox", ref: this.checkBoxRef }),
            React.createElement("button", { onClick: function () { var _a; return console.log((_a = _this.checkBoxRef.current) === null || _a === void 0 ? void 0 : _a.checked); } }, "Test Checkbox")));
    };
    return Echo;
}(React.Component));
exports.Echo = Echo;
//# sourceMappingURL=Echo.js.map